import React from 'react';

const NearbyContent = props => {
  const { trails } = props;
  return (
    <React.Fragment>
      <ul className="flex flex-col justify-between w-full">
        <li className="flex justify-between w-full mb-1 text-base text-gray-900">
          <span className="text-lg font-medium">Hiking Trail</span>
          <span className="text-lg font-medium">Location</span>
        </li>
        {trails.map(trail => {
          const { title, parent_title } = trail;

          return (
            <li
              key={title}
              className="flex justify-between w-full mb-1 text-sm text-gray-900 md:text-base">
              {title}
              <span className="text-gray-500">{parent_title}</span>
            </li>
          );
        })}
      </ul>
    </React.Fragment>
  );
};

export default NearbyContent;
